export const apiName = 'api';
export const infoOpSysName = 'InfoOpSys';
export const marketName = 'Market';



// WEBPACK FOOTER //
// ./src/api/index.js